var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BrandTable',{attrs:{"userId":_vm.userId,"token":_vm.token}})
}
var staticRenderFns = []

export { render, staticRenderFns }